import React from 'react';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>{/* jhipster-needle-add-route-path - JHipster will add routes here */}</ErrorBoundaryRoutes>
    </div>
  );
};
